import { Component } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { AngularFireDatabase } from 'angularfire2/database';
import { AuthProvider } from "../../providers/authservice/auth";

@Component({
  selector: 'page-restaurentservers',
  templateUrl: 'restaurentservers.html',
})
export class RestaurentserversPage {
  isToggled: boolean = false;
  userObj: any;
  restKey: string;
  email: string;
  listServers: any = [];
  isLoading: boolean = true;
  path: string;
  message: string;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public af: AngularFireDatabase,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public openModel: ModalController,
    public authService: AuthProvider) {
    this.userObj = JSON.parse(localStorage.getItem('UserObj'));
    this.restKey = this.userObj.clientId;
    this.path = 'restaurants/' + this.restKey + '/servers';
    this.isLoading = true;
    this.af.list(this.path).snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    }).subscribe((res) => {
      this.listServers = res;
      this.isLoading = false;
    });

    console.log(this.isToggled);
  }

  /* alertModel() {
     let alertModal = this.openModel.create(CustomepopupComponent, { userId: 8675309 });
     alertModal.present();
   }*/
  ionViewDidLoad() {
    console.log('ionViewDidLoad RestaurentserversPage');
  }

  addServer() {
    let userID = '';
    let alrtCtrl = this.alertCtrl.create({
      title: 'Add Restaurants Server',
      message: '',
      inputs: [
        {
          name: 'email',
          placeholder: 'Enter email address'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Save',
          handler: data => {
            console.log(data.email);


            if (!data.email || data.email.length < 1)
              return;
            this.message = '';

            let isModified = false;
            if (!isModified)
              this.af.list(this.path, ref => {
                let obj1 = ref.orderByChild('email').equalTo(data.email);
                return obj1;
              }).valueChanges().subscribe((servers) => {
                if (servers.length > 0) {
                  let toast = this.toastCtrl.create({
                    message: 'Server already exists',
                    duration: 3000,
                    position: 'top'
                  });
                  toast.present();
                  data.email = "";
                  return;
                }
                else {

                  if (!data.email || data.email.length < 1)
                    return;

                  this.af.list('users', ref => {
                    let obj = ref.orderByChild('email').equalTo(data.email).limitToLast(1);
                    return obj;
                  }).snapshotChanges().map(changes => {
                    return changes.map(c => ({ key: c.payload.key, ...c.payload.val() as any }));
                  }).subscribe(
                    (res) => {
                      if (res.length == 1) {
                        let obj = res[0];
                        if (obj.clientId && obj.clientId.length > 0) {
                          let toast = this.toastCtrl.create({
                            message: 'Manager email Id cannot link to Servers',
                            duration: 3000,
                            position: 'top'
                          });
                          toast.present();
                          data.email = "";
                          return;
                        }

                        let serverObj = { userUID: obj.key, fullname: obj.fullname ? obj.fullname : '', email: obj.email, isAvailable: false, URL: obj.URL ? obj.URL : '', desc: obj.desc ? obj.desc : '' };
                        //  this.af.list(this.path).push(serverObj).then(res => { console.log(JSON.stringify(res)); });
                        this.authService.updateWaiterDetails(this.path, obj.key, serverObj);
                        this.af.object('users/' + obj.key + '/waiterTo').set(this.restKey);
                        data.email = "";
                        isModified = true;
                      }
                      else {
                        data.email = "";
                        let toast = this.toastCtrl.create({
                          message: 'User does not exists in our system',
                          duration: 3000,
                          position: 'top'
                        });
                        toast.present();
                      }
                    });
                }
              });
          }
        }
      ]
    });
    alrtCtrl.present();
  }


  setOnline(item) {

    let serverAvilPath = this.path + '/' + item.key + '/isAvailable';
    let key = item.key;
    if (item.isAvailable) {
      item.isAvailable = false;
      this.af.object(serverAvilPath).set(item.isAvailable);
    }
    else {
      item.isAvailable = true;
      this.af.object(serverAvilPath).set(item.isAvailable);
    }
  }

  turnOfforOn(item) {
    item.isAvailable = !item.isAvailable;
    this.af.list(this.path).update(item.key, item);
  }

  removeItem(item) {
    this.af.list(this.path).remove(item.key);
  }
}



// WEBPACK FOOTER //
// ./src/pages/restaurentservers/restaurentservers.ts